import { render } from "./Configuracao.vue?vue&type=template&id=66be1019&scoped=true"
import script from "./Configuracao.vue?vue&type=script&lang=js"
export * from "./Configuracao.vue?vue&type=script&lang=js"

import "./Configuracao.vue?vue&type=style&index=0&id=66be1019&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66be1019"]])

export default __exports__